<template>
  <div>
    <div class="p10 font15 fontblod">建信服务会员</div>
    <div class="mt30 paddtop10" style="width: 100%;">
      <div v-if="!loading && finished">
        <div v-if="thail && thail.length > 0">
          <div class="whiteg paddbot10 mcenter" style="position: relative;">
            <div><van-image width="100vw" height="40" :src="require('@/assets/vip/vipbg.png')" :class="[vipActive == 'com'?'':'trans']"></van-image></div>
            <div style="position: absolute;top:0;line-height: 40px;" class="fontblod">
              <div class="wid50 ftleft" :class="[vipActive == 'com'?'colw':'']" @click="getType('com')">集团会员</div>
              <div class="wid50 ftleft" :class="[vipActive != 'com'?'colw':'']" @click="getType('per')">个人会员</div>
              <div class="clear"></div>
            </div>
            <div class="mt20" style="width: 100%;">
              <div class="mb15">
                <div class="font15 fontblod mb10 mleft ml10">VIP会员收费</div>
                <div class="ftleft mb10" v-for="(it,ke) in thail" :key="ke" @click="toPay(it,ke)" v-if="vipActive == 'per'">
                  <div v-if="it.num && it.num > 0" class="bors1 hei100 mcenter ml7" :class="[active == it.ProductId && yearActive && yearActive.num == it.num ? 'active1' : 'bor1']" >
                    <div class="fontblod font17">VIP</div>
                    <div class="colPrice mt7 font20"><span class="font16">￥</span><span class="fontblod">{{it.price}}</span></div>
                    <div class="mt5 col6">{{it.num}}年</div>
                    <div class="colred font13" v-if="it.num == 1">限时优惠<span class="bortop">￥1888</span></div>
                  </div>
<!--                  <div v-if="it.ProductId == 'S-SVIP'" class="bors1 hei100 mcenter ml7" :class="[active == it.ProductId ? 'active1' : 'bor1',!canBuy&&'bgf0 col9']">
                    <div class="fontblod font17">季会员</div>
                    <div class="font20 colPrice mt7" v-if="it.PromotPrice">
                      <span class="font16">￥</span><span class="fontblod">{{it.PromotPrice}}</span>
                    </div>
                    <div class="font13 colred mt7">仅限首次体验</div>
                  </div>-->
                </div>
                <div class="ftleft mb10" v-for="(it,ke) in comVipType" :key="ke" @click="toPay(it,ke)" v-if="vipActive == 'com'">
                  <div class="bors1 hei100 mcenter ml7" :class="[active == it.ProductId && yearActive && yearActive.num == it.num? 'active1' : 'bor1']">
                    <div class="fontblod font17">VIP</div>
                    <div class="colPrice mt7 font20"><span class="font16">￥</span><span class="fontblod">{{it.price}}</span></div>
                    <div class="mt7 col6">{{it.num}}年</div>
                  </div>
                </div>
                </div>
                <div class="clear"></div>
              </div>
          </div>
          <div class="linedas"></div>
          <div class="mt15" v-if="vipActive == 'per'">
            <div class="font15 mleft ml10 fontblod">SVIP会员收费</div>
            <div class="colred mleft font14 p10">成为VIP会员才可解锁SVIP会员！已是VIP会员需升级SVIP可联系客服！</div>
            <div class="">
              <div v-for="(it,ke) in thail" :key="ke" class="ftleft mt10" @click="toPaySvip(it,ke)" v-if="it.svipPrice">
                <div class="bors1 hei100 mcenter ml7" :class="[sactive.num == it.num&& it.ProductId == sactive.ProductId? 'active1' : 'bor1',it.num != yearActive.num && 'bgf0 col9']" v-if="it.num">
                  <div class="fontblod font17">SVIP</div>
                  <div class="font20 mt7" :class="[it.num != yearActive.num?'col9':'colPrice']"><span class="font16">￥</span><span class="fontblod">{{it.svipPrice}}</span></div>
                  <div class="mt7 col6">{{it.num}}年</div>
                </div>
              </div>
              <div class="clear"></div>
            </div>
          </div>
        </div>
        <div v-else>暂无数据</div>
<!--        <div v-if="thail && thail.length > 0">
          <div class="font15 fontblod mb10 mleft ml10">VIP会员收费</div>
          <div class="ftleft mb10" v-for="(it,ke) in thail" :key="ke" @click="toPay(it,ke)" v-if="vipActive == 'per'">
            <div v-if="it.num && it.num > 0" class="bors mcenter ml7" :class="[active == it.ProductId && yearActive && yearActive.num == it.num ? 'active' : 'bor1']" >
              <div class="fontblod font17">VIP</div>
              <div class="colPrice mt7 font20"><span class="font16">￥</span><span class="fontblod">{{it.price}}</span></div>
              <div class="mt7 col6">{{it.num}}年</div>
            </div>
            <div v-if="it.ProductId == 'S-SVIP'" class="bors mcenter ml7" :class="[active == it.ProductId ? 'active1' : 'bor1',!canBuy&&'bgf0 col9']">
              <div class="fontblod font17">季会员</div>
              <div class="font20 colPrice mt7" v-if="it.PromotPrice">
                <span class="font16">￥</span><span class="fontblod">{{it.PromotPrice}}</span>
              </div>
              <div class="font13 colred mt7">仅限首次体验</div>
            </div>
          </div>
          <div class="clear"></div>
          <div class="linedas"></div>
          <div class="mt15">
            <div class="font15 mleft ml10 fontblod">SVIP会员收费</div>
            <div class="colred mleft font14 p10">成为VIP会员才可解锁SVIP会员！已是VIP会员需升级SVIP可联系客服！</div>
            <div v-for="(it,ke) in thail" :key="ke" class="ftleft mt10" @click="toPaySvip(it,ke)" v-if="it.svipPrice">
              <div class="bors1 hei100 mcenter ml7" :class="[sactive.num == it.num&& it.ProductId == sactive.ProductId? 'active1' : 'bor1',it.num != yearActive.num && 'bgf0 col9']" v-if="it.num">
                <div class="fontblod font17">SVIP</div>
                <div class="font20 mt7" :class="[it.num != yearActive.num?'col9':'colPrice']"><span class="font16">￥</span><span class="fontblod">{{it.svipPrice}}</span></div>
                <div class="mt7 col6">{{it.num}}年</div>
              </div>
            </div>
            <div class="clear"></div>
          </div>
        </div>-->
        <div class="padd3 bgf8 mt10"></div>
        <div class="paddzy10">
          <div class="font14 fontblod mt10 ml10">会员声明</div>
          <div class="bgwhite p10 bor8 font13">
            <div class="mt7" v-for="(ik,kk) in vipDesc" :key="kk">
              <div>{{(kk + 1) +"、" + ik.con}}<span v-if="ik.name == 'kf'" class="col00">联系客服</span>
                <span v-if="ik.name == 'fp'" class="paddzy10 col00" @click="toPay('com',1)">联系客服</span>
<!--                <span style="vertical-align: -10%" class="ml10" v-if="ik.name == 'zh'" ><van-icon size="15" :name="require('@/assets/vip/copy.png')"></van-icon></span>-->
                <div v-if="ik.name == 'zh'&&ik.list&&ik.list.length > 0" class="ml20">
                  <div class="mt5" v-for="(im,km) in ik.list" :key="km">{{im}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="padd3 bgf8"></div>
        <div v-if="active" class="">
          <div class="font14 fontblod padd10 ml10">会员权益</div>
          <div class="p5">
            <div class="viptable font14 mcenter">
              <div class="viptr bg1">
                <div class="vipcell1 vipleft col1">功能模块</div>
                <div class="vipcell2  vipright">
                  <div class="viptr bg1">
                    <div class="vipcell borright vipcenter"><div class="paddzy5">功能</div></div>
                    <div class="vipcell borright vipitem">VIP</div>
                    <div class="vipcell borright vipitem1">VIP+SVIP</div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div class="viptable font14">
                <div class="viptr bg2" v-for="(it,ke) in vipPowerList" :key="ke">
                  <div class="vipcell1 vipleft"><div class="paddzy5">{{it.title}}</div></div>
                  <div class="vipcell2 vipright" v-if="it.list && it.list.length > 0">
                    <div class="viptr bg2" :class="[kk != it.list.length - 1?'borbuttom':'']" v-for="(ik,kk) in it.list" :key="kk">
                      <div class="vipcell borright vipcenter"><div class="paddzy5">{{ik.content}}</div></div>
                      <div class="vipcell3 borright vipitem2 mcenter colred" v-if="ik.vip == 99 && ik.svip == 99">付费下载</div>
                      <div v-else>
                        <div class="vipcell borright vipitem mcenter"  v-if="ik.vip != 99">
                          <span v-if="ik.dis != undefined" class="col2">1</span>
                          <span v-if="ik.vip == 50" class="colred">单日限50个</span>
                          <span v-else-if="ik.vip == 98" class="colred">VIP限免</span>
                          <van-icon v-else :name="!ik.vip?'cross':'success'" size="18" :color="!ik.vip?'#d81e06':'#FAAF1E'"/>
                          <span v-if="ik.dis != undefined" class="col2">82</span>
                        </div>
                        <div class="vipcell borright vipitem1 mcenter" v-if="ik.svip != 99">
                          <span v-if="ik.dis != undefined" class="col2">1</span>
                          <span v-if="ik.vip == false" class="fontblod font13" style="font-style: italic;color: #FAAF1E;">SVIP</span>
                          <van-icon v-else :name="!ik.svip?'cross':'success'" size="18" :color="!ik.svip?'#d81e06':'#FAAF1E'"/>
                          <span v-if="ik.dis != undefined" class="col2">82</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
<!--          <div>
            <van-grid column-num="3">
              <van-grid-item icon="photo-o" use-slot :clickable="true" :text="it.name" v-for="(it,ke) in funcInfo" :key="ke">
                <div class="mcenter" style="height: 70px;">
                  <van-icon :name="require('@/assets/dingyue.png')" :size="34"/>
                  <div class="mt7 font14">{{it.name}}</div>
                </div>
              </van-grid-item>
            </van-grid>
          </div>-->
        </div>
        <div class="padd30 mt30"></div>
      </div>
      <div v-else>
        <van-loading size="30" color="#1890ff" vertical><span class="mt10 colchose">加载中...</span></van-loading>
      </div>
      <div class="padd20"></div>
    </div>
    <div class="padd20"></div>

      <div style="position: fixed;bottom: 50px;width: 100vw">
        <div v-if="activeType.type == 'DONATE'" class="bgwhite" style="border-top: 1px solid #ddd;">
          <div class="font15 colPrice mt7 ml10 fontblod">{{activeType.name}}</div>
          <div class="mt10 paddzy15">
            <div style="border-top: 1px solid #f2f2f2;"></div>
          </div>
          <div>
            <van-field v-model.number="donatePrice" placeholder="请输入打赏金额" @input="priceChange" type="number" clearable/>
          </div>
          <div style="border-top: 1px solid #f2f2f2"></div>
          <div class="padd5"></div>
        </div>
        <div v-if="discount && discount.length > 0">
          <div class="" style="border-top: 1px solid #ddd;"></div>
          <div class="paddzy10 bgwhite">
            <div class="font15 fontblod padd10 ml10 colPrice">年限</div>
            <div class="padd10">
              <div v-for="(it,ke) in discount" :key="ke" class=" ftleft mr10" style="position: relative;" @click="toPay('year',it)">
                <div style="position: absolute;right: 0px;top: -20px"><van-tag plain type="danger" round size="medium" class="fontblod font13">{{it.discount}}折</van-tag></div>
                <!-- <span style="position: absolute;top: -15px;border: 1px solid darkorange;background-color: ;border-radius: 15%;padding: 2px 5px;">{{it.discount}}</span> -->
                <span class="bor1 font14 bgwhite  " :class="[yearActive.num == it.num?'active1':'bor1']" style="padding: 12px 20px;"><span class="fontblod font20">{{it.num}}</span>{{year=='s'?"季度":(year=='m'?"个月":"年")}}</span>
              </div>
              <div class="clear"></div>
            </div>
            <div class="padd8 bgwhite"></div>
            <div style="border-top: 1px solid #f2f2f2"></div>
          </div>
        </div>
      </div>

      <van-submit-bar
          :price="price"
          :button-text="vipActive == 'per'?(niche ? '支付' : '提交订单'):'请联系客服'"
          @submit="onSubmit"
          bar-class="colda"
      />
      <div v-if="pctype == false"></div>
      <div v-else class="mcenter colred">请在手机微信上打开并操作</div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import wx from "weixin-js-sdk";
import {Toast} from "vant";
import {toSubscribe} from "@/utils/utils";

export default {
  name: "jxfwVip",
  data(){
    return{
      price: 0,
      phoneNum: {},
      thail: [],
      active: "",
      funcInfo: [],
      islate: false,
      imgurl: "",
      niche: false,
      types: "",
      tokens: {
        token: ""
      },
      code: "",
      url: "",
      loading: false,
      finished: false,
      pctype: false,
      state: "",
      from: "",
      istiyan: "",
      year: 1,
      discount: [],
      yearActive: {},
      activeType: {
        name: "",
        type: "",
      },
      donatePrice: null,
      payLoading: false,
      canBuy: false,
      sactive: {},
      vipActive: "per",
      comVipType: [],
      vipPowerList: [
        {title: "标讯(交易项目)",list: [
            {content: "项目筛选、搜索",vip: true,svip: true},
            {content: "原文查看",vip: true,svip: true},
            {content: "招标文件、清单解析",vip: true,svip: true},
            {content: "项目竞争预测分析",vip: true,svip: true},
            {content: "项目报价复盘",vip: true,svip: true},
            {content: "进度关联",vip: true,svip: true},
          ]},
        {title: "文件下载",list: [
            {content: "招标文件pdf",vip: 50,svip: true},
            {content: "招标文件、清单、图纸、补遗、开标、中标等原始文件",vip: 99,svip: 99},
            {content: "开标企业明细",vip: true,svip: true},
          ]},
        {title: "项目跟踪、订阅",list: [
            {content: "跟踪项目(开标、补遗等通知)",vip: true,svip: true},
            {content: "项目、资质、业主、代理、企业订阅",dis: 1,vip: true,svip: true},
          ]},
        {title: "企业大数据分析",list: [
            {content: "招标分析",vip: true,svip: true},
            {content: "投标报价分析",vip: true,svip: true},
            {content: "投标表现分析",vip: true,svip: true},
            {content: "企业竞争分析",vip: true,svip: true},
            {content: "人员疑似在建查询",vip: false,svip: true},
            {content: "企业资质查询",vip: true,svip: true},
            {content: "信用中国查询",vip: false,svip: true},
            {content: "裁判文书网查询",vip: false,svip: true},
            {content: "备案业绩分析、查询",vip: true,svip: true},
          ]},
        {title: "查询服务",list: [
            {content: "参与项目查询",vip: true,svip: true},
            {content: "重庆交易日程",vip: false,svip: true},
            {content: "西藏公司筛选",vip: false,svip: true},
            {content: "项目经理考勤查询",vip: false,svip: true},
            {content: "四库业绩",vip: 98,svip: true},
            {content: "全国公路",vip: 98,svip: true},
            {content: "部分省份在线开标大厅",vip: true,svip: true},
            {content: "部分区域信用平台查询",vip: true,svip: true},
            {content: "从企业库中筛选满足企业",vip: false,svip: true},
          ]},
        {title: "工具与社区",list: [
            {content: "安全聊天",vip: true,svip: true},
            {content: "同行名片",vip: true,svip: true},
            {content: "建筑社区",vip: true,svip: true},
            {content: "报价计算器",vip: true,svip: true},
          ]},
        {title: "建材与商机",list: [
            {content: "建材需求项目、数量、金额",vip: true,svip: true},
            /*{content: "商机订阅",vip: true,svip: true},*/
          ]},
      ],
      vipDesc: [],
    }
  },
  created() {
    this.initData();
    this.getCode();
    this.pctype = false;
    //let ua = window.navigator.userAgent.toLowerCase();
    let plat = navigator.platform;
    //alert("1--"+plat);
    let win = plat.indexOf("Win") == 0;
    let mac = plat.indexOf("Mac") == 0;
    if (win || mac) {
      this.pctype = true
    }
  },
  mounted() {
    this.getPrice();
    this.getSPrice();
    //this.login()
  },
  methods:{
    getCode(){
      /*let href = "https://sixu.work/jxpay?code=0215mrll2y2Q384NSPll2yyy9q05mrlB&state=70aec52f26e3451c89e609ff6c80307c&from=lidongy&isTiYan=1"
      if (href.indexOf("state") != -1){

        this.code= id.code;
        this.state = id.state;
        console.log("state",qs.parse(window.location.href.split("#")[0].split("?")[1]));
      }*/
      //this.url = window.location.href
      if (window.location.href.indexOf("code") != -1){
        let id = qs.parse(window.location.href.split("#")[0].split("?")[1])
        this.code = id.code;
        this.state = id.state;
        //Toast("code--",this.code);
        this.from = id.from;
        this.istiyan = id.isTiYan
      }
      //this.code = "0d3qyN000Gz0KP19q4100qhFrY3qyN02";
    },
    initData(){
      this.price = 0;
      this.phoneNum = {};
      this.active = "";
      this.funcInfo = [];
      this.niche = false;
      this.types = "";
      this.tokens = {
        token: ""
      }
      this.code = "";
      this.url = "";
      this.loading = false;
      this.finished = false;
      this.state = "";
      this.from = "";
      this.istiyan = "";
      this.year = 1;
      this.discount = [];
      this.yearActive = {};
      this.activeType =  {
        name: "",
        type: "",
      };
      this.donatePrice = null;
      this.payLoading = false;
      this.vipActive = "per";
      this.showCom = false;
      this.sactive = {};
      this.canBuy = false;
      this.comVipType = [];
      this.vipDesc = [
        {name: "xn",con: "本产品会员为虚拟商品，购买后不支持退款；"},
        {name: "fh",con: "严禁使用非法手段获取本产品数据，一旦发现将对该账号进行封禁处理；"},
        {name: "fp",con: "发票说明："},
        {name: "kf",con: "VIP会员如需补充叠加购买SVIP会员可"},
        {name: "zh",con: "企业对公账号：",list: ["成都四小牛科技有限公司","统一社会信用代码：91510107MA6AY8YY9W","开户银行：中国工商银行股份有限公司成都九眼桥","账户号码：4402217009100194283"]},
      ];
    },
    async toCopyKp(list){

      try {
        // 获取要复制的内容
        const textToCopy = document.getElementById('contentToCopy').innerText;
        // 使用Clipboard API复制内容到剪贴板
        console.log("1-----",textToCopy)
        await navigator.clipboard.writeText(textToCopy);
        // 显示成功消息或者执行其他操作
        alert('内容已复制到剪贴板');
      } catch (err) {
        console.error('复制失败', err);
        // 处理错误，例如显示错误消息
        alert('复制失败，请手动复制');
      }
      /*if (navigator.clipboard) {
        let val = list.join("\n")
        navigator.clipboard.writeText(val).then(res => {
          console.log('文本已复制到剪贴板');
        }).catch(err => {
          console.error('复制失败', err);
        });
      }*/
    },
    priceChange(e){
      this.price = 0;
      this.price = this.donatePrice * 100
    },
    onSubmit(){
      if (this.vipActive == 'com'){
        Toast("购买企业会员请联系客服")
      }else {
        if (this.price > 0){
          this.payLoading = true;
          this.getOrders();
        }else {
          Toast("请选择会员类型")
        }
      }
    },
    getType(name){
      this.vipActive = name;
      console.log("vipActive",this.vipActive,this.thail)
      if (name == "com"){
        this.toPay(this.comVipType[0],0);
        if (this.vipDesc.length == 5){
          this.vipDesc.splice(2,0,{name: 'jt',con: "集团会员管理员可进行子账号管理；"})
          this.vipDesc.splice(3,0,{name: 'kf',con: "集团会员最多可添加5个账号，增加子账号请"})
        }
      }else {
        this.toPay(this.thail[0],0);
        if (this.vipDesc.length > 5){
          this.vipDesc.splice(2,2)
        }
      }
    },
    toPaySvip(it,ke){
      if (this.yearActive && it.num != this.yearActive.num){
        Toast("当前年份无法选中，请先选择VIP相应年份！")
      }else {
        this.sactive = it;
        this.price = (this.yearActive.price + it.svipPrice) * 100;
      }
    },
    toPay(it,ke){
      console.log("1222",it)
      if (this.istiyan && this.istiyan == "1"){
        this.price = it.FirstTimePrice*100;
      }else if(it == "year"){
        this.price = ke.price * 100;
        this.yearActive = ke;
        console.log("yearActive",this.yearActive)
      }else {
        if (!this.canBuy && it.ProductId == 'S-SVIP'){
          Toast("您已购买过会员，无法购买季会员！")
        }else {
          if (it.ProductId != 'DONATE_A') {
            if (it.num) {
              this.price = it.price * 100;
            } else {
              this.price = it.PromotPrice * 100;
            }
          } else {
            this.price = 0
          }
          this.active = it.ProductId;
          this.funcInfo = it.infoDesc;
          this.$set(this.activeType, "name", it.ProductName);
          this.$set(this.activeType, "type", it.ProductType)
          this.discount = [];
          this.year = "";
          this.yearActive = {};
          this.sactive = {};
          this.yearActive = it;
          if (it.Discount) {
            if (it.ProductId.indexOf("M-") != -1) {
              this.year = "m";
            }
            if (it.ProductId.indexOf("S-") != -1) {
              this.year = "s";
            }
            if (it.ProductId.indexOf("Y-") != -1) {
              this.year = "y";
            }
            /*this.discount = it.Discount;
          this.yearActive = this.discount[0];*/
          }
        }
      }
    },
    getOrders(){
      let data = {
        payType: this.active,
        code: this.code,//"031OutFa1Lrs0G0qivGa19aNUT3OutFt"
        payMode:"wxmp",
        state: this.state,
        from: this.from,
        isTiYan: this.istiyan,
      }
      //console.log("yearActive",this.yearActive,this.active)
      if (this.yearActive && this.yearActive.num && this.active != "S-SVIP"){
        data.num = this.yearActive.num;
        data.price = this.yearActive.price;
      }
      if (this.sactive && this.sactive.num > 0){
        data.num = this.sactive.num;
        data.price = this.sactive.total;
        data.isSvip = 1;
      }
      if (this.activeType.type == "DONATE"){
        data.num = this.donatePrice
      }
      axios.post("https://jz.4lambs.com:443/jxfw/pay/getOrder",data).then(res => {
        if (res != null && res.data != null && res.data.content != null){
          let id = res.data.content;
          if (typeof window.WeixinJSBridge == "undefined") {
            if (document.addEventListener) {
              setTimeout(() => {
                document.addEventListener('WeixinJSBridgeReady', toSubscribe(id), false);
              },1000)
            } else if (document.attachEvent) {
              document.attachEvent('WeixinJSBridgeReady', toSubscribe(id));
              document.attachEvent('onWeixinJSBridgeReady', toSubscribe(id));
            }
          } else {
            toSubscribe(id);
          }
        }else {
          if (res.data.errorMsg == "授权失败"){
            Toast("获取订单失败，请重新发起")
            setTimeout(() => {
              window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx73d999be9bec0d08&redirect_uri=https%3A%2F%2Fwx.sixu.work%2Fjxpay&response_type=code&scope=snsapi_base&state=payJx#wechat_redirect"
            },200)
          }else {
            Toast(res.data.errorMsg)
          }
        }
      })
    },
    getPrice(){
      this.loading = true;
      this.finished = false;
      this.thail = [];//beta
      axios.get("https://jz.4lambs.com:443/jxfw/pay/product").then(res => {
        //console.log("res--price",res);
        if (res != null && res.data != null && res.data.content != null){
          this.thail = res.data.content;
          let list = [];
          let index = null;
          if (this.thail && this.thail.length > 0){
            for (let i in this.thail){
              let it = this.thail[i];
              /*if (it.ProductFunc){
                let info = JSON.parse(it.ProductFunc);
                it.infoDesc = info;
                //console.log("info",info)
              }*/
              if (it.Discount){
                it.Discount = JSON.parse(it.Discount)
                if (it.Discount.length > 0){
                  it.Discount.forEach(e => {
                    e.ProductId = it.ProductId;
                    list.push(e)
                  })
                }
              }else {
                list.push(it);
              }
             /* if (it.ProductId == "SJ-VIP"){
                list.push(it)
              }*/
              if (it.ProductId == this.types){
                index = i;
              }
            }
            this.thail = list;
          }
          if (this.types && index != null){
            if (this.thail[index].num){
              this.price = this.thail[index].price * 100;
            }else {
              this.price = this.thail[index].PromotPrice * 100
            }
            this.active = this.thail[index].ProductId;
            //this.funcInfo = this.thail[index].infoDesc;
            this.discount = this.thail[index].Discount;
            this.yearActive = this.thail[index];
            /*this.price = this.thail[index].PromotPrice * 100;
            this.active = this.thail[index].ProductId;
            this.funcInfo = this.thail[index].infoDesc;
            this.discount = this.thail[index].Discount;
            if (this.discount && this.discount.length > 0){
              this.yearActive = this.discount[0];
            }*/
          }else {
            this.price = this.thail[0].price * 100;
            this.active = this.thail[0].ProductId;
            this.yearActive = this.thail[0]
            /*this.price = this.thail[0].PromotPrice * 100;
            this.active = this.thail[0].ProductId;
            this.funcInfo = this.thail[0].infoDesc;
            if (this.thail[0] && this.thail[0].Discount){
              this.discount = this.thail[0].Discount;
              if (this.discount && this.discount.length > 0){
                this.yearActive = this.discount[0];
              }
            }*/
          }
          if (this.thail && this.thail.length > 0){
            this.loading = false;
            this.finished = true;
          }
        }else {
          Toast(res.data.errorMsg);
          this.loading = false;
          this.finished = true;
        }
      })
    },
    getSPrice(){
      axios.get("https://jz.4lambs.com:443/jxfw/pay/entproduct").then(res => {
        if (res != null && res.data != null && res.data.content != null){
          let da = res.data.content;
          let list = [];
          if (da && da.length > 0){
            for (let i in da){
              let it = da[i];
              if (it.Discount){
                it.Discount = JSON.parse(it.Discount)
                if (it.Discount.length > 0){
                  it.Discount.forEach(e => {
                    e.ProductId = it.ProductId;
                    list.push(e)
                  })
                }
              }else {
                list.push(it);
              }
            }
            this.comVipType = list;
            console.log("comVip---svip",list)
          }
        }
      })
    },
    login(){
      let _this = this;
      wx.login({
        success: function (res){
          if (res.code){
            _this.code = res.code
            let param = {
              code: res.code,
            }
            axios.post("https://jz.4lambs.com:443/jxfw/sys/login",param).then(res => {
              if (res && res.data && res.data.content){
                _this.tokens.token = res.data.content.token;
                //setStorage("jxfw_token",JSON.stringify(res.data.content))
              }
            })
          }
        }
      })
    },
  },
}
</script>

<style scoped>
.bors{padding: 12px 0 10px 0;border-radius: 5px;width: 28vw;height: 115px;}
.active{border: darkorange solid 1px;}
.bortop{text-decoration: line-through;}
.blackg{background: #333333;height: 180px;width: 100vw; padding-top: 5px;}
.gloadg{background: linear-gradient(to right,rgb(253,246,214),rgb(247,200,114));width: 90vw;margin: 0 auto;
  padding: 10px 0;border-radius: 20px;}
.bor1{border: #f2f2f2 solid 2px;}
.colPrice{color: rgb(214,166,82);}
.active1{border: rgb(214,166,82) solid 2px;background: rgba(214,166,82,0.1);color: rgb(214,166,82);}

.vips .van-grid-item__content{padding: 10px 0 0px 0}

.whiteg{background: white;border-radius: 15px 15px 0 0; margin-top: -30px;}
.bors1{padding: 10px 0;border-radius: 8px;width: 30vw;}
.hei100{height: 90px;}
.vips .van-grid-item__content{padding: 10px 0 0px 0}
.wid50{width: 50vw;}
.trans{transform: scaleX(-1)}

.viptable {display: table;width: 96vw;table-layout: fixed;word-wrap: break-word;border-collapse: collapse;}
.viptable .bg1{background: #FAAF1E;}
.viptable .col1{color: #FAAF1E;}
.viptable .bg2{background: #FFF8EC;}
.viptable .col2{color: #FFF8EC;}
.viptable .vipcell1 {display: table-cell;border: 1px solid #FFEECD;padding: 5px 0;}
.viptable .vipcell {display: table-cell;padding: 5px 0;}
.viptable .vipcell3 {display: table-cell;padding: 5px 0;}
.viptable .vipcell2 {display: table-cell;border: 1px solid #FFEECD;vertical-align: middle;}
.viptable .border {}
.viptable .borbuttom {border-bottom: 1px solid #FFEECD;}
.viptable .borright {border-right: 1px solid #FFEECD;}
.viptable .viptr {display: table-row;}
.viptable .vipleft {width: 19vw;}/*#F5FCFA*/
.viptable .vipright {width: 77vw;}
.viptable .vipcenter {width: 50vw;}
.viptable .vipitem {width: 10vw;}
.viptable .vipitem1 {width: 17vw;}
.viptable .vipitem2 {width: 27vw;}
.linedas{border-bottom: 1px dashed #d1d1d1;}
.bgf0{background-color: #F0F0F0;}
</style>